import * as React from 'react'
import { FullLogo } from './FullLogo'

type Breakpoint = 'sm' | 'md' | 'lg' | 'xl'

type Props = React.SVGProps<SVGSVGElement> & {
  collapsed?: boolean
  autoFrom?: Breakpoint // od którego breakpointu pokazujemy: collapsed ? sygnet : full
}

// Tailwind skanuje kod jako TEKST, wiec klasa sklejona w szablonie (`${bp}:tw-hidden`)
// nigdy nie trafia do CSS. Wczesniej dzialalo to przypadkiem - "md:tw-hidden" wystepowalo
// doslownie w ekranach ustawien i stamtad wchodzilo do arkusza. Gdy te pliki znikly,
// regula przestala istniec, sygnet przestal sie chowac i logo pokazywalo sie dwa razy.
// Oba warianty musza byc zapisane doslownie.
const VARIANTS: Record<Breakpoint, { sygnet: string; desktop: string }> = {
  sm: { sygnet: 'tw-block sm:tw-hidden', desktop: 'tw-hidden sm:tw-block' },
  md: { sygnet: 'tw-block md:tw-hidden', desktop: 'tw-hidden md:tw-block' },
  lg: { sygnet: 'tw-block lg:tw-hidden', desktop: 'tw-hidden lg:tw-block' },
  xl: { sygnet: 'tw-block xl:tw-hidden', desktop: 'tw-hidden xl:tw-block' },
}

export const ResponsiveLogo = ({
  collapsed = false,
  autoFrom = 'md',
  ...svgProps
}: Props) => {
  const variant = VARIANTS[autoFrom]

  return (
    <>
      {/* xs..(<bp): zawsze sygnet */}
      <FullLogo collapsed className={variant.sygnet} {...svgProps} />

      {/* >=bp: collapsed albo full */}
      <FullLogo
        collapsed={collapsed}
        className={variant.desktop}
        {...svgProps}
      />
    </>
  )
}
